import { useMemo } from "react";
import useValue from "../../../../../hooks/forms/useValue.js";
import { useSearcherFlightHotelProps, useSearcherFlightHotelState } from "../context/index.js";
const useSearcherFlightHotelView = ()=>{
    const props = useSearcherFlightHotelProps();
    const { classes  } = props ?? {};
    const state = useSearcherFlightHotelState();
    const { discounts  } = state ?? {};
    const originValue = useValue({
        name: 'origin'
    });
    const destinationValue = useValue({
        name: 'destination'
    });
    const datesValue = useValue({
        name: 'dates'
    });
    const accommodationValue = useValue({
        name: 'accommodation'
    });
    const mustShowClasses = !!classes?.length;
    const mustShowDiscounts = useMemo(()=>!!originValue && !!destinationValue && !!datesValue && !!accommodationValue && !!discounts?.length, [
        accommodationValue,
        datesValue,
        destinationValue,
        discounts,
        originValue
    ]);
    return {
        mustShowClasses,
        mustShowDiscounts
    };
};
export default useSearcherFlightHotelView;

//# sourceMappingURL=useSearcherFlightHotelView.js.map